import { component } from 'picoapp'
import { zelektor, loopify } from '@/lib/utility-functions.js'
import { subscribe } from 'klaviyo-subscribe'

export default component((node,ctx) => {
    const { email, successMessage, formElement: formElements = [], submitBtn } = zelektor(node)
    const { listId } = node.dataset

    node.addEventListener('submit', e => {
        e.preventDefault()

        submitBtn.innerText = window.theme.strings.newsletter.sending

        subscribe(listId, email.value, {})
        .then(response => {
            if (response.success) {
                loopify(formElements).forEach(element => element.style.display = 'none')
                successMessage.style.display = ''
            } else {
                alert(response.errors)
            }
        })
    })
})